const constants = {
    EVIDENCE: "Evidence"
};
export { constants as FILTER_TYPES_CONSTANTS };
